<template>
    <div>
        <eg-modal scrollable :height="dynamicHeight" :width="dynamicWidth" :show="show" @close="close()">
            <p class="center" slot="header">Informe seu dados e em breve entraremos em contato com você.</p>
            <div slot="body" class="row">
                <eg-alert :show="showAlert" :message="message" :color="colorAlert" @show="showAlert = $event" />
                <div class="col xl12 l12 m12 s12">
                    <div class="input-field">
                        <eg-input
                            :value="name"
                            v-model.trim="name"
                            name="email"
                            placeholder-text="Nome*"
                            :has-icon="true"
                            background-color="#FFF"
                            icon="fas fa-user"
                            :rules="textRules"
                            @valid="textRules.valid = $event"
                        />
                    </div>
                    <div class="input-field">
                        <eg-input
                            :mask="['(##) ####-####', '(##) #####-####']"
                            :value="telephone"
                            v-model.trim="telephone"
                            name="telephone"
                            placeholder-text="Telefone*"
                            :has-icon="true"
                            background-color="#FFF"
                            icon="fas fa-phone-alt"
                            :rules="textRules"
                            @valid="textRules.valid = $event"
                        />
                    </div>
                    <div class="input-field">
                        <eg-input
                            :value="tradingName"
                            v-model.trim="tradingName"
                            name="tradingName"
                            placeholder-text="Empresa*"
                            :has-icon="true"
                            background-color="#FFF"
                            icon="fas fa-building"
                            :rules="textRules"
                            @valid="textRules.valid = $event"
                        />
                    </div>
                    <div class="input-field">
                        <eg-input
                            :value="email"
                            v-model.trim="email"
                            name="email"
                            placeholder-text="E-mail*"
                            :has-icon="true"
                            background-color="#FFF"
                            icon="fas fa-envelope"
                            :rules="emailRules"
                            @valid="emailRules.valid = $event"
                        />
                    </div>
                    <div class="input-field">
                        <eg-input
                            :value="job"
                            v-model.trim="job"
                            name="job"
                            placeholder-text="Cargo*"
                            :has-icon="true"
                            background-color="#FFF"
                            icon="fas fa-briefcase"
                            :rules="textRules"
                            @valid="textRules.valid = $event"
                        />
                    </div>
                    <div class="input-field">
                        <eg-input
                            :value="website"
                            v-model.trim="website"
                            name="website"
                            placeholder-text="Website"
                            :has-icon="true"
                            background-color="#FFF"
                            icon="fas fa-link"
                        />
                    </div>
                </div>
            </div>
            <div slot="footer">
                <button :disabled="!formValid" @click="validateForm" :class="`btn ${btnColor} darken-4`">
                    Solicitar contato
                </button>
            </div>
        </eg-modal>
    </div>
</template>

<script>
import { SUBSCRIPTION_ALERT } from '@/utils/constants';
import { subscriptionNotification } from '@/services';
import { mapState } from 'vuex';

export default {
    name: 'subscription-alert',
    data: () => ({
        completedForm: false,
        notificationModal: false,
        showAlert: false,
        message: '',
        colorAlert: 'red',
        name: '',
        telephone: '',
        tradingName: '',
        email: '',
        website: '',
        job: '',
        textRules: {
            name: '',
            type: 'text',
            required: true,
            valid: true
        },
        emailRules: {
            name: 'E-mail',
            type: 'email',
            required: true,
            valid: true
        },
        isMobile: false
    }),
    props: {
        show: Boolean,
        plan: String,
        origin: {
            type: String,
            default: ''
        },
        openInicialize: {
            type: Boolean,
            default: false
        }
    },
    created() {
        if (this.$route.params.openPlansModal && this.openInicialize) this.$emit('close', true);
    },
    methods: {
        close() {
            this.sendNotificationBannerData();
            this.$emit('close', false);
        },
        validateForm() {
            if (
                this.name != '' &&
                this.email != '' &&
                this.telephone != '' &&
                this.job != '' &&
                this.tradingName != ''
            ) {
                if (this.formValid) {
                    this.sendNotification();
                }
            } else {
                this.message = 'Preencha os campos Nescessários';
                this.colorAlert = 'red';
                this.textRules.valid = false;
                this.showAlert = true;
            }
        },
        async sendNotification() {
            const data = this.buildData();
            data.send = true;
            this.$gtag.event('Premium', {
                event_category: 'Fornecedor'
            });
            const responseNotification = await subscriptionNotification(data);
            this.sendDataToCookie(responseNotification);
            this.completedForm = true;
            this.redirectToComplement();
            this.close();
        },
        async sendDataToCookie(responseNotification) {
            this.$cookies.set('complement_info', responseNotification.id, 60 * 60);
        },
        redirectToComplement() {
            this.$router.push({ name: 'complementSpecialist' });
        },
        sendNotificationBannerData() {
            if (!this.completedForm && this.name.length && this.telephone.length) {
                this.completedForm = true;
                this.$gtag.event('Premium', {
                    event_category: 'Fornecedor'
                });
                subscriptionNotification(this.buildData());
            }
        },
        buildData() {
            const authenticated = !!this.user.key;
            return {
                name: this.name,
                phone: this.telephone,
                email: this.email,
                tradingName: this.tradingName,
                plan: this.plan,
                authenticated,
                origin: this.setOrigin,
                send: false,
                website: this.website,
                job: this.job
            };
        }
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    destroyed() {
        this.sendNotificationBannerData();
    },
    computed: {
        ...mapState('user', ['user']),
        setOrigin() {
            switch (this.$route.name) {
            case 'CompetitionDashboardGuest':
                return `${this.setSubscriptionOrigin} - painel para visitantes`;
            case 'CompetitionDashboard':
                return `${this.setSubscriptionOrigin} - painel de cotações para fornecedores`;
            case 'MyContacts':
                return `${this.setSubscriptionOrigin} - painel de contatos para fornecedores`;
            case 'MyOpportunities':
                return `${this.setSubscriptionOrigin} - painel de oportunidades para fornecedores`;
            case 'ContactNetwork':
                return `${this.setSubscriptionOrigin} - ${SUBSCRIPTION_ALERT.CONTACT_NETWORK}`;
            case 'GuestContactNetwork':
                return `${this.setSubscriptionOrigin} - ${SUBSCRIPTION_ALERT.CONTACT_NETWORK} para visitantes`;
            }
            return 'nao encontrado';
        },
        setSubscriptionOrigin() {
            if (this.origin) {
                switch (this.origin) {
                case 'banner':
                    return SUBSCRIPTION_ALERT.BANNER;
                case 'modal':
                    return SUBSCRIPTION_ALERT.PLANS;
                }
                return SUBSCRIPTION_ALERT.PLANS;
            } else {
                return 'não sei';
            }
        },
        btnColor() {
            return this.formValid ? 'blue' : 'gray';
        },
        formValid() {
            return this.emailRules.valid && this.textRules.valid ? true : false;
        },
        dynamicHeight() {
            return this.isMobile ? 'auto' : '500px';
        },
        dynamicWidth() {
            return this.isMobile ? '90%' : '400px';
        }
    }
};
</script>

<style></style>
